import "./telemetry";
import React from "react";
import ReactDOM from "react-dom/client";
import { resolveBackendUrl } from "./utils/backendUrl";

import "./index.css";

const ensureFontLoad = () => {
  const createLoader = () => {
    const loader = document.createElement("span");
    loader.style.position = "absolute";
    loader.style.left = "-9999px";
    loader.style.visibility = "hidden";
    loader.style.fontFamily = '"Inter", sans-serif';
    loader.style.fontWeight = "400";
    loader.style.fontSize = "14px";
    loader.textContent = "Inter font preload";
    return loader;
  };

  if (document.body) {
    const loader = createLoader();
    document.body.appendChild(loader);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(() => {
          if (loader.parentNode) {
            document.body.removeChild(loader);
          }
        })
        .catch(() => {
          if (loader.parentNode) {
            document.body.removeChild(loader);
          }
        });
    } else {
      setTimeout(() => {
        if (loader.parentNode) {
          document.body.removeChild(loader);
        }
      }, 500);
    }
  } else {
    const loader = createLoader();
    document.documentElement.appendChild(loader);

    const checkBody = setInterval(() => {
      if (document.body) {
        clearInterval(checkBody);
        if (loader.parentNode === document.documentElement) {
          document.documentElement.removeChild(loader);
        }
        ensureFontLoad();
      }
    }, 10);
  }
};

const renderApp = async () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureFontLoad);
  } else {
    ensureFontLoad();
  }

  // Resolve backend URL before importing any other modules
  await resolveBackendUrl();

  // Dynamically import App so its static dependencies (like services)
  // use the resolved backend URL
  const { default: App } = await import("./App");

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(<App />);
};

renderApp();
